<template>
  <v-data-table
    must-sort
    :headers="headers"
    :items="items"
    :no-data-text="$t('dataTable.noExpiringCertificates')"
    :hide-default-footer="true"
    item-key="id"
    show-expand
    :sort-by="['notAfter']"
    :sort-desc="[true]"
  >
    <template v-slot:item.issuer="{ item }">
      <span>{{ trim(item.issuer, issuerTrim) }}</span>
    </template>
    <template v-slot:item.serialNumber="{ item }">
      <span>{{ trim(item.serialNumber, serialNumberTrim) }}</span>
    </template>
    <template v-slot:item.notAfter="{ item }">
      <span>{{ convertDate(item.notAfter) }}</span>
    </template>
    <template v-slot:expanded-item="{ headers, item }">
      <td :colspan="headers.length">
        <pre>
          <v-card flat>
            <v-simple-table dense>
              <template v-slot:default>
                <thead>
                  <tr>
                    <th class="text-left">Field</th>
                    <th class="text-left">Value</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-if="item.signerName">
                    <td>{{ $t('name') }}</td>
                    <td>{{ item.signerName }}</td>
                  </tr>
                  <tr>
                    <td>{{ $t('serialNumber') }}</td>
                    <td>{{ item.serialNumber }}</td>
                  </tr>
                  <tr>
                    <td>{{ $t('issuer') }}</td>
                    <td>{{ item.issuer }}</td>
                  </tr>
                  <tr>
                    <td>{{ $t('subject') }}</td>
                    <td>{{ item.subject }}</td>
                  </tr>
                  <tr>
                    <td>{{ $t('notBefore') }}</td>
                    <td>{{ convertDate(item.notBefore) }}</td>
                  </tr>
                  <tr>
                    <td>{{ $t('notAfter') }}</td>
                    <td>{{ convertDate(item.notAfter) }}</td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-card>
        </pre>
      </td>
    </template>
  </v-data-table>
</template>

<script>
export default {
  name: 'ExpandableDataTable',

  props: {
    headers: {
      type: Array,
      default: undefined
    },
    items: {
      type: Array,
      default: undefined
    },
    issuerTrim: {
      type: Number,
      default: undefined
    },
    serialNumberTrim: {
      type: Number,
      default: undefined
    }
  },

  methods: {
    trim(value, length) {
      if (length != null) {
        return value.length > length ? value.substring(0, length) + '...' : value
      }
      return value
    }
  }
}
</script>
